import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import alertCircle from '../../../assets/svgs/alert-circle.svg';
import alertTriangle from '../../../assets/svgs/alert-triangle.svg';
import clsx from 'clsx';

interface TypeColumnIconnProps {
    isItIncident: boolean
};

const useStyles = makeStyles<Theme>((theme) => ({
    icon: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        minHeight: 30,
        border: 0
    },
    iconTringle: {
        'filter': 'invert(36%) sepia(96%) saturate(1083%) hue-rotate(331deg) brightness(101%) contrast(89%)'
    },
    iconCircle: {
        'filter': 'invert(79%) sepia(77%) saturate(919%) hue-rotate(335deg) brightness(97%) contrast(98%)'
    },
}));


const TypeColumnIcon: React.FC<TypeColumnIconnProps> = ({ isItIncident }) => {
    const classes = useStyles();
    const iconClassForIncident = clsx(classes.icon, classes.iconTringle);
    const iconClassForOverload = clsx(classes.icon, classes.iconCircle);
    return (
        <div>
            <img
                src={isItIncident ? alertTriangle : alertCircle}
                width="30"
                height="30"
                className={isItIncident ? iconClassForIncident : iconClassForOverload} /> 
        </div>
    );
}

export default TypeColumnIcon;
